/**
 * Contract Notices Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.6.13
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ResourceRequest { 
    type: ResourceRequest.TypeEnum;
    filename: string;
    contentType: string;
    fileSize?: number;
}
export namespace ResourceRequest {
    export type TypeEnum = 'NOTICE' | 'ANNOUNCEMENT' | 'SALE' | 'BANKRUPTCY' | 'SCREENSHOT';
    export const TypeEnum = {
        NOTICE: 'NOTICE' as TypeEnum,
        ANNOUNCEMENT: 'ANNOUNCEMENT' as TypeEnum,
        SALE: 'SALE' as TypeEnum,
        BANKRUPTCY: 'BANKRUPTCY' as TypeEnum,
        SCREENSHOT: 'SCREENSHOT' as TypeEnum
    };
}